import * as React from "react";
const ClothesExtraCorporateFemale = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 1080 1920"
	>
		<defs>
			<style>
				{
					".cls-extra-corp-fem-1{fill:none;}.cls-extra-corp-fem-2{fill:#282b2e;}.cls-extra-corp-fem-3{fill:#191e24;}.cls-extra-corp-fem-4{clip-path:url(#clip-path-extra-corp-fem);}.cls-extra-corp-fem-5{fill:#282c32;}.cls-extra-corp-fem-6{fill:#f26962;}.cls-extra-corp-fem-7{fill:#fbfbfb;}"
				}
			</style>
			<clipPath id="clip-path-extra-corp-fem">
				<path
					className="cls-extra-corp-fem-1"
					d="M801.17,907.65s-10.5-149.1-14.7-168-21-98.7-25.2-111.3-5.42-104.87-8.4-140.7c-2.1-25.2-14.7-39.9-29.4-50.4s-56.7-29.4-77.7-39.9c-12.6-37.8-42-46.2-42-46.2v18.9c2.1,4.2,8.4,10.5,8.4,10.5s2.1,2.1,2.1,8.4c-4.2,35.7-52.5,39.9-52.5,39.9s-48.3-4.2-52.5-39.9c0-6.3,2.1-8.4,2.1-8.4s6.3-6.3,8.4-10.5v-18.9s-29.4,8.4-42,46.2c-21,10.5-63,29.4-77.7,39.9s-27.3,25.2-29.4,50.4c-3,35.83-4.2,128.1-8.4,140.7s-21,92.4-25.2,111.3-14.7,168-14.7,168l2.1,2.1-2.1,18.9s12.6,12.6,48.3,8.4a78.67,78.67,0,0,0,2.1-16.8l4.2-2.1s31.5-142.8,33.6-157.5,21-159.6,21-159.6,10.5,107.1,8.4,119.7-25.2,111.3-25.2,111.3,65.1,33.6,147,33.6A315,315,0,0,0,593.29,864c1.4-.14,2.08-4.69,2.08-6.79,2.1,2.1,2.1,6.3,6.37,5.83,62.13-7.85,107-31,107-31s-23.1-98.7-25.2-111.3,8.4-119.7,8.4-119.7,18.9,144.9,21,159.6,33.6,157.5,33.6,157.5l4.2,2.1a78.67,78.67,0,0,0,2.1,16.8c35.7,4.2,48.3-8.4,48.3-8.4l-2.1-18.9Z"
				/>
			</clipPath>
		</defs>
		<title>{"habit corporate ++ f"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect className="cls-extra-corp-fem-1" width={1080} height={1920} />
		</g>
		<g id="corporate_f" data-name="corporate ++ f">
			<path
				className="cls-extra-corp-fem-2"
				d="M477,1727s-4.43,18-4.43,24.25-2.47,42.14-4.2,52.5c-2.1,12.6,1,43.81,4.2,56.7,2.1,8.4,18.9,12.6,25.2,14.7s16.8,2.1,21,0,10.5-4.2,12.6-8.4,6.3-23.1,6.3-23.1,4.2-12.6,0-29.4c0-4.2-.67-84.25-.67-84.25s-.61-11.09-3-14c1.81,9.69,1,21,1,21v40s3,20-1.53,35.15c-6.3,8.4-50.4,4.2-50.4,4.2s-10.5.12-10.5-18.9c0-12.32,2.67-30.84,4.2-46.2A135.13,135.13,0,0,0,477,1727Z"
			/>
			<path
				className="cls-extra-corp-fem-2"
				d="M641,1722s5,19.75,5,26,2.47,42.14,4.2,52.5c2.1,12.6-1,43.81-4.2,56.7-2.1,8.4-18.9,12.6-25.2,14.7s-16.8,2.1-21,0-10.5-4.2-12.6-8.4-6.3-23.1-6.3-23.1-4.2-12.6,0-29.4c0-4.2,2.1-84,2.1-84s.56-11.14,3-14-.85,22.45-.85,22.45l-2.1,31.5s-1,27,2.1,42c6.3,8.4,50.4,4.2,50.4,4.2s10.5.12,10.5-18.9c0-12.32-2.68-30.84-4.2-46.2A213.74,213.74,0,0,1,641,1722Z"
			/>
			<path
				className="cls-extra-corp-fem-3"
				d="M719.27,901.35c-2.1-21-18.9-73.5-18.9-73.5l-138.6,4.2-138.6-4.2s-16.8,52.5-18.9,73.5,10.5,399,21,417.9,136.5,23.1,136.5,23.1,126-4.2,136.5-23.1S721.37,922.35,719.27,901.35Z"
			/>
			<g className="cls-extra-corp-fem-4">
				<path
					className="cls-extra-corp-fem-5"
					d="M801.17,907.65s-10.5-149.1-14.7-168-21-98.7-25.2-111.3-5.42-104.87-8.4-140.7c-2.1-25.2-14.7-39.9-29.4-50.4s-56.7-29.4-77.7-39.9c-12.6-37.8-42-46.2-42-46.2v18.9c2.1,4.2,8.4,10.5,8.4,10.5s2.1,2.1,2.1,8.4c-4.2,35.7-52.5,39.9-52.5,39.9s-48.3-4.2-52.5-39.9c0-6.3,2.1-8.4,2.1-8.4s6.3-6.3,8.4-10.5v-18.9s-29.4,8.4-42,46.2c-21,10.5-63,29.4-77.7,39.9s-27.3,25.2-29.4,50.4c-3,35.83-4.2,128.1-8.4,140.7s-21,92.4-25.2,111.3-14.7,168-14.7,168l2.1,2.1-2.1,18.9s12.6,12.6,48.3,8.4a78.67,78.67,0,0,0,2.1-16.8l4.2-2.1s31.5-142.8,33.6-157.5,21-159.6,21-159.6,10.5,107.1,8.4,119.7-25.2,111.3-25.2,111.3,65.1,33.6,147,33.6A315,315,0,0,0,593.29,864c1.4-.14,2.08-4.69,2.08-6.79,2.1,2.1,2.1,6.3,6.37,5.83,62.13-7.85,107-31,107-31s-23.1-98.7-25.2-111.3,8.4-119.7,8.4-119.7,18.9,144.9,21,159.6,33.6,157.5,33.6,157.5l4.2,2.1a78.67,78.67,0,0,0,2.1,16.8c35.7,4.2,48.3-8.4,48.3-8.4l-2.1-18.9Z"
				/>
				<path
					className="cls-extra-corp-fem-3"
					d="M478.2,396.1s1.67,41.15,8,51.65a131.19,131.19,0,0,1,23.1,10.5s-12.6,14.7-14.7,23.1a405.27,405.27,0,0,0,35.7,50.4c18.48,22,42.49,42.61,50.4,52.5-10.5-27.3-14.7-31.5-14.7-31.5s44.1-31.5,75.6-79.8c-6.3-12.6-14.7-16.8-14.7-16.8l25.2-10.5s2.1-37.8-6.3-48.3c4.2-14.7,0-48.3,0-48.3l-44.1-12.6H498.77l-27.3,27.3Z"
				/>
				<path
					className="cls-extra-corp-fem-6"
					d="M614.22,387.35s-43.33-3.93-52.45,28.9c-9.12-32.83-52.45-28.9-52.45-28.9-8.34,69.79,39.85,133.9,52.45,161.2C574.37,521.25,622.56,457.14,614.22,387.35Z"
				/>
				<circle
					className="cls-extra-corp-fem-7"
					cx={561.77}
					cy={582.15}
					r={6.3}
				/>
				<path
					className="cls-extra-corp-fem-6"
					d="M324.47,909.75s16.8,12.6,48.3,10.5,10.5,27.3,10.5,27.3l-71.4-2.1-8.4-18.9Z"
				/>
				<path
					className="cls-extra-corp-fem-6"
					d="M799.63,909.75s-16.8,12.6-48.3,10.5-10.5,27.3-10.5,27.3l71.4-2.1,8.4-18.9Z"
				/>
			</g>
		</g>
	</svg>
);
export default ClothesExtraCorporateFemale;
